<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import AppShell from '@/components/AppShell.vue';

const route = useRoute();

// Маршруты, на которых не показываем layout (логин, callback)
const isBareRoute = computed(() => route.meta.bare === true);
</script>

<template>
  <AppShell v-if="!isBareRoute">
    <RouterView />
  </AppShell>
  <RouterView v-else />
</template>
